import { FC, useState, useEffect } from 'react';
import InputLabel from 'raydiant-elements/core/InputLabel';
import Input from 'raydiant-elements/core/Input';
import Text from 'raydiant-elements/core/Text';
import {
  getPropertyLogoutQsParam,
  setPropertyLogoutQsParam,
} from '../../utilities/properties';
import { useApplicationFormContext } from '../../hooks/useApplicationForm';

interface ApplicationLogoutQsParamProps {}

const ApplicationLogoutQsParam: FC<ApplicationLogoutQsParamProps> = () => {
  const {
    isEditable,
    version,
    selectedProperty,
    updateSelectedProperty,
  } = useApplicationFormContext();

  // State

  const [logoutQsParam, setLogoutQsParam] = useState('');

  // Callbacks

  const handleBlur = () => {
    if (!version) return;
    if (!selectedProperty) return;

    updateSelectedProperty(
      setPropertyLogoutQsParam(selectedProperty, logoutQsParam),
      version.strings,
    );
  };

  // Effects

  // Set "logout qs param" when selectedProperty changes.
  useEffect(() => {
    setLogoutQsParam(
      selectedProperty ? getPropertyLogoutQsParam(selectedProperty) || '' : '',
    );
  }, [selectedProperty]);

  // Render

  return (
    <div>
      {isEditable && (
        <>
          <InputLabel>Logout Query String Parameter</InputLabel>
          <Input
            type="text"
            value={logoutQsParam}
            onChange={setLogoutQsParam}
            onBlur={handleBlur}
          />
        </>
      )}

      {!isEditable && selectedProperty && (
        <>
          <InputLabel>Logout Query String Parameter</InputLabel>
          <Text>{getPropertyLogoutQsParam(selectedProperty)}</Text>
        </>
      )}
    </div>
  );
};

export default ApplicationLogoutQsParam;
